<div class="footer-wrap">

    <div class="footer-content">

        <div>
            {{ 'FOOTER.TITLES.COPYRIGHT_1' | translate }}
            {{ currentYear }}
            {{ 'FOOTER.TITLES.COPYRIGHT_2' | translate }}
        </div>

        @if (version != null) {
        <div class="version">
            {{ version }}
        </div>
        }

    </div>

</div>